import dynamicfunction from "../utils/dynamicfunction";
import { cn } from "../utils/utils";

const ErrorText = ({ text = "", numbers, className, getContentKey, isCenter }) => {
  const { TextWeight, TextAlign } = dynamicfunction();

  if (!text) return null;

  return (
    <p
      className={cn('text-red-600 text-xs mt-2', TextWeight.light, isCenter ? "text-center" : TextAlign, className)}
    >
      {getContentKey ? getContentKey(text) : text} {numbers}
    </p>
  );
};

export default ErrorText;
